export const shiftBreakCacheKeys = {
  warning: (queryParams = {}) => ['floating_breaks_warning', queryParams]
}
